import * as React from 'react';

import * as cs from './ThemeSentinel.module.css';

interface Props {
  primaryColor?: string;
  secondaryColor?: string;
}

let counter = 0;

function getSentinelId() {
  return `sentinel-${counter++}`;
}

export const ThemeSentinel = ({ primaryColor, secondaryColor }: Props) => {
  const [sentinelId] = React.useState(() => getSentinelId());
  return (
    <div
      data-sentinel-id={sentinelId}
      data-primary-color={primaryColor || ''}
      data-secondary-color={secondaryColor || ''}
      data-sentinel
      className={cs.root}
    />
  );
};
